import { Injectable } from "@angular/core";
import { DrawingService } from "./DrawingService";
import { CookiesService } from "./cookieService";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root"
  })
  export class SettingsService {

    public showEventsSignal:Subject<boolean> = new Subject<boolean>();
    private _showEvents: boolean = false;
    public get showEvents(): boolean {
        return this._showEvents;
    }
    public set showEvents(value: boolean) {
       
        this._showEvents = value;
        if(this.drawingService)
        {
            this.saveLocalSettingsForEvents(this.drawingService.selectedViewName);
            this.showEventsSignal.next(true);
        }
    }

    public saveLocalSettingsForEvents(settings:string)
    {
        var localSettings:EventsSettings = 
        {
            eventsIsActive: this.showEvents
        }
        window.localStorage.setItem(`${settings}_events`, JSON.stringify(localSettings));
        //console.log(settings);
    }

    public loadLocalSettingsForEvents(settings:string)
    {
        var localSettings = window.localStorage.getItem(`${settings}_events`);
        if(localSettings)
        {
            var ob:EventsSettings = JSON.parse(localSettings);
            this.showEvents = ob.eventsIsActive;
        }
        //console.log(settings);
    }


    public selectedMinBarRights:number = 1;
    public showChartEventSignal:Subject<boolean> = new Subject<boolean>();
    private _showChartEvent: boolean = true;
    public get showChartEvent(): boolean {
        return this._showChartEvent;
    }
    public set showChartEvent(value: boolean) {
       
        this._showChartEvent = value;
        if(this.drawingService)
        {
            this.saveLocalSettingsForChartEvent(this.drawingService.selectedViewName);
            this.showChartEventSignal.next(true);
        }
    }

    public saveLocalSettingsForChartEvent(settings:string)
    {
        var localSettings:ChartEventSettings = 
        {
            ChartEventIsActive: this.showChartEvent
        }
        window.localStorage.setItem(`${settings}_ChartEvent`, JSON.stringify(localSettings));
        //console.log(settings);
    }

    public loadLocalSettingsForChartEvent(settings:string)
    {
        var localSettings = window.localStorage.getItem(`${settings}_ChartEvent`);
        if(localSettings)
        {
            var ob:ChartEventSettings = JSON.parse(localSettings);
            this.showChartEvent = ob.ChartEventIsActive;
        }
        //console.log(settings);
    }


    public setRightBarState(state:boolean)
    {
        window.localStorage.setItem(`${this.drawingService.selectedViewName}_rightbar`, JSON.stringify(state));
    }


    public getRightBarState()
    {
        var value = window.localStorage.getItem(`${this.drawingService.selectedViewName}_rightbar`);
        if(value!=null)
        {
            return (value=='true')?true:false;
        }
        else
        {
            return true;
        }
    }


    public setAdvanceState(state:number)
    {
        window.localStorage.setItem(`${this.drawingService.selectedViewName}_advancestate`,  state.toString());
    }

    public getAdvanceState()
    {
        var value = window.localStorage.getItem(`${this.drawingService.selectedViewName}_advancestate`);
        if(value!=null)
        {
            return (value=='1')?1:0;
        }
        else
        {
            return 0;
        }
    }


    private _selectedEventsMode: number = 0;
    public get selectedEventsMode(): number {
        return this._selectedEventsMode;
    }
    public set selectedEventsMode(value: number) {
        this._selectedEventsMode = value;
        //this.setAdvanceState(value);
    }







    private _showUpperMagniture: boolean = false;
    public get showUpperMagniture(): boolean {
        return this._showUpperMagniture;
    }
    public set showUpperMagniture(value: boolean) {
       
        this._showUpperMagniture = value;
        if(this.drawingService)
        {
            this.saveLocalSettingsForView(this.drawingService.selectedViewName);
            this.drawingService.redrawUpperMagniter.next(true);
        }
    }

    private _diffValue: number = 34.5;
    public get diffValue(): number {
        return this._diffValue;
    }
    public set diffValue(value: number) {
        this._diffValue = value;
        if(this.drawingService)
        {
            this.saveLocalSettingsForView(this.drawingService.selectedViewName);
            this.drawingService.redrawUpperMagniter.next(true);
        }
    }

    public drawingService: DrawingService;
    /**
     *
     */
    constructor(private cookieService: CookiesService) {
        var initView = this.cookieService.getCookie("_view");
        if(initView)
        {
            this.loadLocalSettingsForView(initView);
            this.loadLocalSettingsForEvents(initView);
            this.loadLocalSettingsForChartEvent(initView);
        }
       
    }

    public loadLocalSettingsForView(settings:string)
    {
        var localSettings = window.localStorage.getItem(`${settings}_view`);
        if(localSettings)
        {
            var ob:LocalSettings = JSON.parse(localSettings);
            this.diffValue = ob.upperMagnituderDiffValue;
            this.showUpperMagniture = ob.upperMagnitudetIsActive
        }
        //console.log(settings);
    }

    public saveLocalSettingsForView(settings:string)
    {
        var localSettings:LocalSettings = 
        {
            upperMagnitudetIsActive: this.showUpperMagniture,
            upperMagnituderDiffValue: this.diffValue
        }
        window.localStorage.setItem(`${settings}_view`, JSON.stringify(localSettings));
        //console.log(settings);
    }
    
   
  }

  export interface LocalSettings
  {
        upperMagnitudetIsActive:boolean,
        upperMagnituderDiffValue:number;
  }

  export interface EventsSettings
  {
    eventsIsActive:boolean,
  }

  export interface ChartEventSettings
  {
    ChartEventIsActive:boolean,
  }